import React from "react";
import MainDrawingWrapper from "../../components/lotto12/MainDrawingWrapper";
import DashboardMix from "../../components/lotto12/mix/DashboardMix";
import BettingDialog from "../../components/lotto5/BettingDialog";
import {useLotto12} from "../../store/lotto12/Lotto12Context";

const Lotto12DashboardMix = ({appClass = ""}) => {
    return <MainDrawingWrapper appClass={appClass} stSize={{ row: 6, column: 7 }} isIframe={true}>
        <Lotto12MixWrapper appClass={appClass}/>
    </MainDrawingWrapper>
}

const Lotto12MixWrapper = ({appClass}) => {
    const lotto = useLotto12();
    return <div className="lotto12-mix m-lotto-1">
        <DashboardMix appClass={appClass} {...lotto}/>
        <BettingDialog
            changeBetAmount={lotto.changeBetAmount}
            clickAmountBetBtn={lotto.clickAmountBetBtn}
            onConfirmBettingLotto5={lotto.onConfirmBetting}
            resetDefaultAmount={lotto.resetDefaultAmount}
            onCancelBetting={lotto.onCancelBetting}
            classDialog="bet-mix-dialog"
            appClass={appClass}
            {...lotto}
        />
    </div>
}

export default Lotto12DashboardMix;
